import React, { useState } from "react";
import { Box, Button, Popover, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';

export type MatchFieldValue = "any" | "name" | "prompt" | "query_terms";

interface ListOption<T> {
  label: string;
  value: T;
}

interface MatchFieldsButtonProps {
  onChange(field: MatchFieldValue): void;
  selectedField: MatchFieldValue;
}

export default function MatchFieldsButton(props: MatchFieldsButtonProps): React.JSX.Element {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const matchFieldOptions: Array<ListOption<MatchFieldValue>> = [{
    label: i18n.t("match-fields-button.options.all"),
    value: "any"
  }, {
    label: i18n.t("match-fields-button.options.prompt"),
    value: "prompt"
  }, {
    label: i18n.t("match-fields-button.options.name"),
    value: "name"
  }, {
    label: i18n.t("match-fields-button.options.query"),
    value: "query_terms"
  }];

  const [matchField, setMatchField] = useState<MatchFieldValue>("any");

  function handleMatchFieldChange(value: MatchFieldValue) {
    setMatchField(value);
    props.onChange(value);
  }

  const open = Boolean(anchorEl);

  return (
    <Box>
      <Button size="small" variant="contained" onClick={(event) => setAnchorEl(event.currentTarget)}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1
          }}>
          <Box>{i18n.t("match-fields-button.label")}</Box>
          <ArrowDropDownIcon/>
        </Stack>
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          horizontal: "right",
          vertical: "top"
        }}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom'
        }}
      >
        <Stack
          sx={{
            minWidth: 150,
            paddingTop: 1,
            paddingBottom: 1
          }}>
          <Typography
            variant="body1"
            sx={{
              paddingRight: 2,
              paddingLeft: 2
            }}>{i18n.t("match-fields-button.label")}</Typography>
          {matchFieldOptions.map((option, index) => {
            return (
              <Box
                key={`MatchFieldsButton.MatchFields.${index}`}
                sx={{
                  paddingRight: 1,
                  paddingLeft: 1
                }}>
                <Button fullWidth onClick={() => handleMatchFieldChange(option.value)} size="small" sx={{justifyContent: "start", paddingTop: 0.5, paddingRight: 1, paddingBottom: 0.5, paddingLeft: 1}}>
                  <Stack direction="row" sx={{
                    alignItems: "center"
                  }}>
                    <Box
                      sx={{
                        display: "flex",
                        marginRight: 1,
                        alignItems: "center"
                      }}>
                      <CheckIcon sx={{visibility: option.value === matchField ? "visible" : "hidden", fontSize: 16}} />
                    </Box>
                    <Typography>{option.label}</Typography>
                  </Stack>
                </Button>
              </Box>
            );
          })}
        </Stack>
      </Popover>
    </Box>
  );
}